import type {
  LLMStreamEvent,
  LLMStreamEventType,
} from '../../../contracts/harness.types';
import { isRecord } from '../../../contracts/parse-utils';

// A Record, not a Set literal: it makes the union exhaustive, so a type added
// to `LLMStreamEventType` without a row here fails to compile rather than being
// silently dropped at runtime.
const LLM_EVENT_TYPE_ALLOWLIST: Record<LLMStreamEventType, true> = {
  message_start: true,
  text_delta: true,
  thinking_delta: true,
  tool_call_complete: true,
  tool_call_start: true,
  tool_input_delta: true,
  message_end: true,
  error: true,
  tool_execution_start: true,
  tool_execution_delta: true,
  tool_execution_complete: true,
  tool_execution_error: true,
  approval_requested: true,
  approval_resolved: true,
  tool_result_blocks: true,
  turn_started: true,
  turn_completed: true,
  turn_cancelled: true,
  turn_failed: true,
  prompt_context_failed: true,
  'remote.tool_request': true,
  'evidence.chunk': true,
};

const LLM_EVENT_TYPES = new Set<string>(Object.keys(LLM_EVENT_TYPE_ALLOWLIST));

export const parseLlmStreamEvent = (data: string): LLMStreamEvent | null => {
  if (!data.trim()) return null;

  let parsed: unknown;
  try {
    parsed = JSON.parse(data);
  } catch {
    return null;
  }

  if (!isRecord(parsed)) return null;
  const type = parsed.type;
  if (typeof type !== 'string' || !LLM_EVENT_TYPES.has(type)) {
    return null;
  }

  const metadata = isRecord(parsed.metadata) ? parsed.metadata : {};

  return {
    ...parsed,
    type: type as LLMStreamEventType,
    metadata,
  } as LLMStreamEvent;
};
